import { api } from '../../lib/api';

export const PROVIDERS = [
  { id: 'whatsapp_meta_cloud', label: 'WhatsApp Meta Cloud', keys: ['access_token', 'phone_number_id'] },
  { id: 'whatsapp_twilio', label: 'WhatsApp Twilio', keys: ['account_sid', 'auth_token', 'from_number'] },
  { id: 'whatsapp_dialog360', label: 'WhatsApp 360dialog', keys: ['api_key', 'endpoint'] },
  { id: 'dian_alegra', label: 'DIAN — Alegra', keys: ['email', 'token'] },
  { id: 'dian_siigo', label: 'DIAN — Siigo', keys: ['username', 'access_key'] },
  { id: 'dian_dataico', label: 'DIAN — Dataico', keys: ['api_key'] },
  { id: 'dian_factura1', label: 'DIAN — Factura1', keys: ['api_key'] },
] as const;

export type ProviderId = (typeof PROVIDERS)[number]['id'];

export async function listIntegrations(): Promise<Record<string, string[]>> {
  const { data } = await api.get<Record<string, string[]>>('/api/settings/integrations');
  return data;
}

export async function setIntegration(provider: ProviderId, key: string, value: string): Promise<void> {
  await api.put('/api/settings/integrations', { provider, key, value });
}

export async function deleteIntegration(provider: ProviderId, key: string): Promise<void> {
  await api.delete('/api/settings/integrations', { data: { provider, key } });
}
